import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { GumroadButton } from "./Gumroad";

export const EbookCover = ({ book, className = "" }) => (
  <div className={`relative aspect-[910/1287] w-full overflow-hidden border border-ink bg-ink ${className}`}>
    <img
      src={book.cover}
      alt={`${book.platform}, end-to-end — Vol. ${book.vol} of The Operator's Manual ebook cover`}
      className="w-full h-full object-cover"
      loading="lazy"
    />
    <span className="absolute top-0 left-0 h-1.5 w-full" style={{ background: book.accent }} />
  </div>
);

export const EbookCard = ({ book, index = 0, compact = false }) => (
  <motion.article
    initial={{ opacity: 0, y: 16 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.5, delay: index * 0.06 }}
    data-testid={`ebook-card-${book.slug}`}
    className="flex flex-col h-full border border-ink bg-paper p-5 md:p-6"
  >
    <Link to={`/playbook/${book.slug}`} className="block group" data-testid={`ebook-cover-link-${book.slug}`}>
      <EbookCover book={book} className="group-hover:shadow-[8px_8px_0_0_#E63946] transition-shadow" />
    </Link>
    <div className="mt-5 flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.22em]">
      <span style={{ color: book.accent }}>Vol. {book.vol}</span>
      <span className="text-ink" data-testid={`ebook-price-${book.slug}`}>${book.price} USD</span>
    </div>
    <h3 className="mt-3 font-heading font-black text-2xl leading-tight tracking-tight">{book.title}</h3>
    <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-ink2">{book.series}</p>
    {!compact && <p className="mt-4 text-[14px] text-ink2 leading-relaxed flex-1">{book.description}</p>}
    <div className={`mt-6 flex flex-col gap-3 ${compact ? "mt-auto pt-6" : ""}`}>
      <GumroadButton
        book={book}
        label="Buy on Gumroad"
        testId={`ebook-buy-${book.slug}`}
        location={compact ? "ebook_other_strip" : "ebook_collection"}
        className="w-full bg-ink text-paper hover:bg-signal px-5 py-4"
      />
      <Link
        to={`/playbook/${book.slug}`}
        data-testid={`ebook-view-${book.slug}`}
        className="w-full inline-flex justify-center border border-ink px-5 py-3.5 font-mono text-[11px] uppercase tracking-[0.22em] hover:bg-ink hover:text-paper transition-colors"
      >
        View ebook
      </Link>
    </div>
  </motion.article>
);
